import React from 'react';
import { Stack } from '@mui/material';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa6';

interface ArrowButtonsProps {
	canGoBack: boolean;
	canGoForward: boolean;
	onPreviousClick: () => void;
	onNextClick: () => void;
}

const ArrowButtons: React.FC<ArrowButtonsProps> = ({
	canGoBack,
	canGoForward,
	onPreviousClick,
	onNextClick
}) =>
{
	return (
		<Stack direction={'row'} pl={1} pb={0.5} spacing={1}>
			<FaAngleLeft
				color={canGoBack ? '#24a4c4' : '#ccc'}
				cursor={canGoBack ? 'pointer' : 'not-allowed'}
				onClick={canGoBack ? onPreviousClick : undefined}
				style={{ opacity: canGoBack ? 1 : 0.5 }}
			/>
			<FaAngleRight
				color={canGoForward ? '#24a4c4' : '#ccc'}
				cursor={canGoForward ? 'pointer' : 'not-allowed'}
				onClick={canGoForward ? onNextClick : undefined}
				style={{ opacity: canGoForward ? 1 : 0.5 }}
			/>
		</Stack>
	);
};

export default ArrowButtons;